import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
	dates: [],
	committees: [],
	reviewers: [],
	dictumTypes: [],
	dictums: [],
	committeeDictums: [],
	assignedReviewers: [],
	assignedReviewerDictums: [],
	protocolTaskAdvance: [],
}

export default {
	namespaced: true,
	actions,
	state,
	mutations,
	getters,
}
